<script setup lang="ts">
  interface Emits {
    (event: "update:text", text: string): void;
  }
  interface Props {
    text: string;
    label?: string;
    type?: string;
    placeholder?: string;
    readonly?: boolean;
    onlyNumber?: boolean;
    maxlength?: number;
    bgColor?: string;
    density?: "default" | "comfortable" | "compact";
    errorMessages?: string[];
  }
  const props = withDefaults(defineProps<Props>(), {
    label: "",
    type: "text",
    placeholder: "",
    readonly: false,
    onlyNumber: false,
    maxlength: Infinity,
    bgColor: "",
    density: "default",
    errorMessages: () => [],
  });

  const mounted = ref(false);
  const emit = defineEmits<Emits>();
  const computedData = computed<string>({
    get: () => {
      // バリデーションを実行するため、マウント前は空文字を返す
      // validate-on="eager"指定でマウント時にバリデーションを実行できるが、空白時にもバリデーションを実行してしまうためこの処理を入れている
      if (!mounted.value) {
        return "";
      }
      return props.text;
    },
    set: value => {
      let content = value;
      // NumberでもMaxlengthを制御
      if (props.maxlength && content.length > props.maxlength) {
        content = content.slice(0, props.maxlength);
      }

      emit("update:text", content);
    },
  });

  const checkKeyCode = (event: any) => {
    if (props.onlyNumber === false) return true;
    // e.+-を除外
    return !(event.keyCode === 69 || event.keyCode === 190 || event.keyCode === 189 || event.keyCode === 187);
  };
  onMounted(() => {
    mounted.value = true;
  });
</script>

<template>
  <v-text-field
    v-model="computedData"
    variant="solo"
    :label="label"
    :type="type"
    :placeholder="placeholder"
    :readonly="readonly"
    :maxlength="maxlength"
    :error-messages="errorMessages"
    :onkeydown="checkKeyCode"
    class="no-spin"
    :bg-color="bgColor"
    :density="density"
    :class="bgColor != '' ? '' : 'bg-color-default'"
  ></v-text-field>
</template>

<style lang="scss" scoped>
  :deep(.v-field--variant-solo) {
    background: rgb(var(--v-theme-monochrome-06));
  }

  .bg-color-default {
    // 自動補完後に背景が白くなる問題の対策。background-colorでは変わらないため、box-shadowを指定。
    :deep(input:-webkit-autofill) {
      box-shadow: 0 0 0 1000px rgb(var(--v-theme-monochrome-06)) inset !important;
      -webkit-text-fill-color: #fff !important;
    }

    // 自動補完後のカーソルが黒になるので、合わせて変更。
    :deep(input:-webkit-autofill:focus) {
      caret-color: #fff !important;
    }
  }

  :deep(.v-input__details) {
    padding-top: 6px !important;
    padding-bottom: 6px !important;
    padding-left: 0px !important;
    padding-right: 0px !important;
  }

  .no-spin {
    :deep(input[type="number"]::-webkit-outer-spin-button),
    :deep(input[type="number"]::-webkit-inner-spin-button) {
      -webkit-appearance: none;
      margin: 0;
    }
  }
</style>
